// extracted by mini-css-extract-plugin
module.exports = {"inheritColorLink":"Legal_inheritColorLink__pEBwp","link":"Legal_link__z6mVn","root":"Legal_root__299Pf","copyrightNotice":"Legal_copyrightNotice__od4od","icon":"Legal_icon__g3RWx"};